export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9079.99a8d656.jpg";